import { useEffect, useState } from 'react'

export const useAsyncEffect = (callback: () => any, deps: any[] = []) => {
  const [status, setStatus] = useState<'loading' | 'error' | 'ready'>('loading')
  useEffect(() => {
    setStatus('loading')
    callback()
      .catch((err) => {
        console.warn(err)
        setStatus('error')
      })
      .then(() => setStatus('ready'))
  }, deps)
  return status
}
